import { colors, radius } from '../styles/theme'

interface ToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  id?: string
  label?: React.ReactNode
  disabled?: boolean
}

export default function Toggle({ checked, onChange, id, label, disabled }: ToggleProps) {
  const toggle = (
    <button
      type="button"
      id={id}
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => !disabled && onChange(!checked)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        width: 36,
        height: 20,
        borderRadius: 10,
        border: 'none',
        padding: 2,
        background: checked ? colors.primary : '#cbd5e1',
        cursor: disabled ? 'default' : 'pointer',
        transition: 'background 0.2s',
        flexShrink: 0,
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <span
        style={{
          display: 'block',
          width: 16,
          height: 16,
          borderRadius: radius.sm,
          background: '#fff',
          boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
          transform: checked ? 'translateX(16px)' : 'translateX(0)',
          transition: 'transform 0.2s',
        }}
      />
    </button>
  )

  if (!label) return toggle

  return (
    <label
      htmlFor={id}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 8, cursor: disabled ? 'default' : 'pointer' }}
      onClick={e => { e.preventDefault(); !disabled && onChange(!checked) }}
    >
      {toggle}
      {label}
    </label>
  )
}
